(function() {
  angular.module('cfn').controller('personCoreController', [
    '$scope',
    '$rootScope',
    'CoreREST',
    'Person',
    '$http',
    '$timeout',
    '$log',
    '$dialog',
    '$injector',
    '$route',
    'FavoriteService',
    'i18nFilter',
    function(
      $scope,
      $rootScope,
      CoreREST,
      Person,
      $http,
      $timeout,
      $log,
      $dialog,
      $injector,
      $route,
      FavoriteService,
      i18nFilter
    ) {
      var mode = {
        name: 'person',
        hasCalendar: true,
        hasActive: true
      };

      var ctrl = this;
      ctrl.getEntityName = function() {
        try {
          return $scope.details.person.combinedName;
        } catch (e) {
          return '';
        }
      };

      var specialAdd = (mode.specialAdd = []);
      var ele = null;
      ele = {};
      ele.property = 'personGroups';
      ele.Property = 'PersonGroups';
      specialAdd.push(ele);
      ele = {};
      ele.property = 'emails';
      ele.Property = 'Emails';
      ele.editable = true;
      specialAdd.push(ele);
      ele = {};
      ele.property = 'telephones';
      ele.Property = 'Telephones';
      ele.editable = true;
      specialAdd.push(ele);
      ele = {};
      ele.property = 'address';
      ele.Property = 'Address';
      ele.editable = true;
      specialAdd.push(ele);
      ele = {};
      ele.property = 'notifications';
      ele.Property = 'Notifications';
      ele.editable = true;
      specialAdd.push(ele);

      // validation engine
      var vgi = {};
      vgi['active'] = '1';
      vgi['number'] = '1';
      vgi['anrede'] = '1';
      vgi['name'] = '1';
      vgi['firstName'] = '1';
      vgi['userInvitation'] = '1';
      vgi['birthday'] = '1';
      vgi['personGroups'] = '1';
      vgi['category_STAFF'] = '1';
      vgi['category_OWNER'] = '1';
      vgi['category_FAMILY'] = '1';
      vgi['category_HELPER'] = '1';
      vgi['category_SEASON'] = '1';
      vgi['emails'] = '2';
      vgi['telephones'] = '2';
      vgi['address'] = '2';
      vgi['activityUnit'] = '3';
      vgi['activityPerHour'] = '3';
      vgi['costs'] = '3';
      vgi['netPrice'] = '3';
      mode.vgi = vgi;

      return coreCommonController(
        'person',
        ctrl,
        mode,
        $scope,
        $rootScope,
        CoreREST,
        Person,
        $http,
        $timeout,
        $log,
        $dialog,
        $injector,
        $route,
        FavoriteService,
        i18nFilter
      );
    }
  ]);
})();
